export var SPECIAL_FOLDER_IDS = ['all', 'gfx', 'pdf'];
export var IMAGE_FILES = 'image/png,image/jpeg,image/jpg';
export var DOCUMENT_FILES = 'application/pdf';
export var ICON_FILES = 'image/svg+xml';
